export const REJECTED_COLUMNS_HEAD = [
  {
    title: "Spec No.",
    dataIndex: "spec_concat",
    key: "spec_concat",
    align: "left",
    width: "130px",
  },
  {
    title: "Card No.",
    dataIndex: "card_no",
    key: "card_no",
    align: "left",
    width: "130px",
  },
  {
    title: "FEC",
    dataIndex: "fec",
    key: "fec",
    align: "center",
    width: "80px",
  },
  {
    title: "Description",
    dataIndex: "task_description",
    key: "task_description",
    align: "left",
  },
];

export const COMPLETED_COLUMNS_HEAD = [
  {
    title: "Spec No.",
    dataIndex: "spec_concat",
    key: "spec_concat",
    align: "left",
    width: "130px",
  },
  {
    title: "Card No.",
    dataIndex: "card_no",
    key: "card_no",
    align: "left",
    width: "130px",
  },
  {
    title: "FEC",
    dataIndex: "fec",
    key: "fec",
    align: "center",
    width: "80px",
  },
  {
    title: "Description",
    dataIndex: "task_description",
    key: "task_description",
    align: "left",
  },
];

export const STYLES = {
  searchBard: {
    borderRadius: "8px",
    backgroundColor: "#EBEEF8",
    color: "#737373",
    display: "flex",
    marginTop: "5px",
  },
  tableTitle: {
    padding: "16px 0px",
    fontSize: "15px",
    fontWeight: 500,
    color: "#484950",
  },
};
